import PlotInfo from './PlotInfo';

export default PlotInfo;
